import { LocationDto } from '@fleet-beat/core';

export interface BoundingBoxDto {
  northEast?: LocationDto;
  southWest?: LocationDto;
  zoom?: number;
}
